import { render, staticRenderFns } from "./SyForm.vue?vue&type=template&id=5558bf50&scoped=true"
import script from "./SyForm.vue?vue&type=script&lang=ts"
export * from "./SyForm.vue?vue&type=script&lang=ts"
import style0 from "./SyForm.vue?vue&type=style&index=0&id=5558bf50&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5558bf50",
  null
  
)

export default component.exports